<div class="inner-item-wrapper" *ngIf="componentData!=undefined">
    <div class="item-container main-content-holder">
        <div class="main-input-form">

            <div class="input-wrapper">
                <div class="side-wrapper edit-form-title-wrapper">
                    <div class="user-icon"></div>
                    <p class="input-form-title">Add form</p>
                </div>
                <div class="menu-input-wrapper">
                    <div class="input-content">
                        <div class="basic-info">
                            <div class="section-wrapper">
                                <p class="section-title">General</p>
                            </div>
                            <div class="side-combiner">
                                <div class="side-input-container">
                                    <div class="input-control">
                                        <div class="title">
                                            <label class="col-sm-2 control-label" for="FormType">Form Type</label>
                                        </div>
                                        <select class="form-control" id="FormType" name="FormType" [(ngModel)]="componentData.FormType">
                                            <option value="0">Standard Form</option>
                                            <option value="1">Parameter Form</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="side-combiner">
                                <div class="side-input-container">
                                    <div class="input-control">
                                        <div class="title"><label class="col-sm-2 control-label"
                                                for="ModelFullName">Model : {{componentData.ModelFullName}}</label></div>
                                        <select class="form-control" id="ModelFullName" name="ModelFullName" [(ngModel)]="componentData.ModelFullName">
                                           <option *ngFor="let mod of componentData.DocumentModels" [value]="mod.Value">
                                                {{mod.Text}}
                                           </option>
                                        </select>
                                    </div>
                                </div>
                                <!--
                                -->
                                <div class="side-input-container">
                                    <div class="input-control">

                                        <div class="title"><label class="col-sm-2 control-label"
                                                for="SubMasterPageId">Sub master page</label></div>
                                        <select class="form-control" id="SubMasterPageId" name="SubMasterPageId" [(ngModel)]="componentData.SubMasterPageId">
                                            SubMasterPages
                                            <option *ngFor="let smp of componentData.SubMasterPages" [value]="smp.Value">
                                                        {{smp.Text}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="side-combiner">
                                <div class="side-input-container">
                                    <div class="input-control">

                                        <div class="title"><label class="col-sm-2 control-label" for="Url">View
                                                Url</label></div>
                                        <input class="form-control" id="Url" name="Url"
                                            type="text"  [(ngModel)]="componentData.Url">

                                    </div>
                                </div>
                                <!--
                                -->
                                <div class="side-input-container">
                                    <div class="input-control">

                                        <div class="title"><label class="col-sm-2 control-label" for="ViewName">View
                                                name</label></div>
                                        <input class="form-control" id="ViewName" name="ViewName" type="text"  [(ngModel)]="componentData.ViewName">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>